import { useModuleRedirect } from "../../hooks/useModuleRedirect";

const FireSystemEntry = () => {
  useModuleRedirect("fire-system");
  return null;
};

export default FireSystemEntry;
